import * as React from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { ThemeContext } from "../context";

export default function ToggleColorMode() {
  const theme = useTheme();
  const { toggleColorMode } = React.useContext(ThemeContext);

  return (
    <Box>
      <Tooltip title="Color Mode">
        <IconButton sx={{ ml: 1 }} onClick={toggleColorMode} color="inherit">
          {theme.palette.mode === "light" ? (
            <Brightness7Icon />
          ) : (
            <Brightness4Icon />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
